import { format } from "date-fns";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useEcomSalesByStatusQuery } from "../../../services/ecomApi";
import "./OrderReceived.css";

const OrderCancel = () => {
  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [sales, setSales] = useState([]);

  const { data, isSuccess } = useEcomSalesByStatusQuery("cancel");

  useEffect(() => {
    if (data?.length > 0) {
      setSales(data);
    }
  }, [isSuccess]);

  return (
    <div className="order-received-container">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Aamar-Dokan-ECOM-SALE</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="order-header">
              <div className="search-filters">
                <div className="date-range-picker">
                  <DatePicker
                    selected={new Date(startDate)}
                    className="form-control date-input"
                    onChange={(date) =>
                      setStartDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                  <DatePicker
                    selected={new Date(endDate)}
                    className="form-control date-input"
                    onChange={(date) =>
                      setEndDate(format(new Date(date), "MM-dd-yyyy"))
                    }
                  />
                </div>
                <div className="search-box">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search invoice id"
                  />
                </div>
              </div>
              <div className="action-buttons">
                <button className="btn btn-export">
                  <Icons.DownloadOutline size={18} className="me-2" />
                  Export Sales Report
                </button>
                <button className="btn btn-export">
                  <Icons.DocumentTextOutline size={18} className="me-2" />
                  Export Article Report
                </button>
              </div>
            </div>

            <div className="table-container">
              <table className="table">
                <thead>
                  <tr>
                    <th>Invoice ID</th>
                    <th>Date</th>
                    <th>Biller</th>
                    <th>Customer</th>
                    <th>Items</th>
                    <th>Gross Total</th>
                    <th>Paid</th>
                    <th>Change</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data.map((sale) => (
                      <tr key={sale._id}>
                        <td className="invoice-id">{sale.invoiceId}</td>
                        <td>
                          {sale.createdAt &&
                            format(new Date(sale.createdAt), "MM-dd-yyyy H:m:ss")}
                        </td>
                        <td>{sale?.billerId?.name}</td>
                        <td>{sale?.customerId?.phone}</td>
                        <td>{sale.totalItem}</td>
                        <td className="amount">৳{sale.grossTotalRound}</td>
                        <td className="amount">৳{sale.totalReceived}</td>
                        <td className="amount">৳{sale.changeAmount}</td>
                        <td>
                          <span className={`status-badge status-${sale.status.toLowerCase()}`}>
                            {sale.status}
                          </span>
                        </td>
                        <td>
                          <Link to={`/ecom/orderinfoupdate/${sale._id}`} className="action-link">
                            <Icons.CogOutline className="action-icon" size={22} />
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="no-data">
                        <div className="no-data-content">
                          <Icons.InboxOutline size={48} />
                          <p>No Orders Found</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCancel;
